<template>
  <div style="min-width: 1200px" class="big">
    <div class="page_title flex_between">
      <span>活动数据</span>
      <el-button type="primary" style="width: 92px" size="medium" @click="back"
        >返回</el-button
      >
    </div>
    <div style="padding: 20px">
      <div class="container">
        <div class="searchbox">
          <div>
            <span>统计时间</span>
            <el-select
              v-model="time_type"
              placeholder="请选择"
              style="margin: 0 16px 0 8px; width: 140px"
              @change="changeType"
            >
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
          <div class="item" v-if="time_type == 1">
            <el-date-picker
              v-model="date"
              type="daterange"
              align="left"
              unlink-panels
              range-separator="~"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="customizeOptions"
              :clearable="false"
              @change="getList"
              style="width: 240px"
              key="day"
            >
            </el-date-picker>
          </div>
          <div class="item" v-if="time_type == 2">
            <el-date-picker
              key="week"
              v-model="week"
              type="week"
              format="yyyy 第 WW 周"
              value-format="yyyy-MM-dd"
              :clearable="false"
              :picker-options="pickerOptions"
              @change="changeWeek"
              style="width: 240px"
            >
            </el-date-picker>
          </div>
          <div class="item" v-if="time_type == 3">
            <el-date-picker
              key="month"
              v-model="month"
              type="month"
              placeholder="选择月"
              @change="changeMonth"
              style="width: 240px"
              :clearable="false"
              align="left"
            >
            </el-date-picker>
          </div>
          <el-button
            type="info"
            style="background-color: #eceff2; color: #747981; margin-left: 6px"
            @click="search"
            >查询</el-button
          >
        </div>
        <div class="num_box">
          <div class="datebox">
            {{ dateData }}
          </div>
          <div class="between" style="flex: 1">
            <div class="num_item">
              <div class="num">{{ count_data.view_num }}</div>
              <div class="gray">浏览量</div>
            </div>
            <div class="num_item">
              <div class="num">{{ count_data.view_person }}</div>
              <div class="gray">浏览人数</div>
            </div>
            <div class="num_item">
              <div class="num">{{ count_data.click_num }}</div>
              <div class="gray">点击量</div>
            </div>
            <div class="num_item">
              <div class="num">{{ count_data.click_person }}</div>
              <div class="gray">点击人数</div>
            </div>
            <div class="num_item">
              <div class="num">{{ count_data.click_rate }}</div>
              <div class="gray">点击率</div>
            </div>
          </div>
        </div>
        <div style="border: solid 1px #c9cbd6">
          <el-table
            ref="multipleTable"
            :data="tableData"
            tooltip-effect="dark"
            style="width: 100%; min-width: 1000px"
            :header-cell-style="{ background: '#F5F5F5' }"
          >
            <el-table-column label="日期" prop="create_time"> </el-table-column>
            <el-table-column label="事件名称" prop="key_name">
            </el-table-column>
            <el-table-column
              label="医生姓名"
              prop="doctor_name"
            ></el-table-column>
            <el-table-column label="手机号" prop="phone"></el-table-column>
            <el-table-column label="区域" prop="area"></el-table-column>
          </el-table>
        </div>
        <div style="padding: 20px 0">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="10"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalNum"
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import dayjs from "dayjs";
export default {
  data() {
    return {
      currentPage: 1,
      pagesize: 10,
      totalNum: 0,
      tableData: [],
      count_data: {},
      date: [],
      month_date: [],
      week_date: [],
      week: "",
      month: "",
      dateData: "",
      pickerOptions: {
        firstDayOfWeek: 1,
      },
      time_type: 1,
      options: [
        {
          value: 1,
          label: "自定义时间",
        },
        {
          value: 2,
          label: "自然周",
        },
        {
          value: 3,
          label: "自然月",
        },
      ],
      customizeOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
    };
  },

  filters: {
    dateFormat(week) {
      return dayjs.unix(week).format("YYYY-MM");
    },
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
  },
  methods: {
    //获取列表
    getList() {
      let data = {
        page: this.currentPage,
        pageNumber: this.pagesize,
        banner_id: this.$route.query.banner_id,
        type: this.$route.query.type,
      };
      if (this.time_type == 1) {
        data.start_time = dayjs(this.date[0]).format("YYYY-MM-DD");
        data.end_time = dayjs(this.date[1]).format("YYYY-MM-DD");
        this.dateData = data.start_time + "~" + data.end_time;
      }
      if (this.time_type == 2) {
        data.start_time = this.week_date[0];
        data.end_time = this.week_date[1];
        this.dateData = data.start_time + "~" + data.end_time;
      }
      if (this.time_type == 3) {
        data.start_time = this.month_date[0];
        data.end_time = this.month_date[1];
        this.dateData = data.start_time + "~" + data.end_time;
      }
      this.axios
        .post("platform/Activity/getDoctorBannerCount", data)
        .then((res) => {
          if (res.code == 0) {
            if (!res.data.list.length && this.currentPage > 1) {
              this.currentPage = this.currentPage - 1;
              this.getList();
            }
            this.tableData = res.data.list.map((item) => {
              item.create_time = dayjs
                .unix(item.create_time)
                .format("YYYY-MM-DD HH:mm:ss");
              return item;
            });
            this.count_data = res.data.count_data;
            this.totalNum = res.data.total;
          }
        });
    },
    changeType() {
      this.date = [];
      this.month_date = [];
      this.week_date = [];
      this.month = "";
      this.week = "";
      this.dateData = "";
      this.$forceUpdate();
    },
    //改变周
    changeWeek(value) {
      let now = new Date(value);
      let now_day = now.getDay();
      if (now_day == 0) {
        now_day = 7;
      }
      let now_time = now.getTime();
      let monDay = dayjs(
        new Date(now_time + 24 * 60 * 60 * 1000 * (1 - now_day))
      ).format("MM-DD");
      let sunDay = dayjs(
        new Date(now_time + 24 * 60 * 60 * 1000 * (7 - now_day))
      ).format("MM-DD");
      let year = dayjs(value).year();
      this.week_date = [year + "-" + monDay, year + "-" + sunDay];
      this.getList();
    },
    //改变月
    changeMonth(value) {
      let start = dayjs(value).format("YYYY-MM-DD");
      let end_time = new Date(value.getFullYear(), value.getMonth() + 1, 0);
      let end = dayjs(end_time).format("YYYY-MM-DD");
      this.month_date = [start, end];
      this.getList();
    },
    //搜索
    search() {
      this.currentPage = 1;
      this.getList();
    },
    //每页数据
    handleSizeChange(size) {
      this.pagesize = size;
      this.getList();
    },
    //翻页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    back() {
      history.back();
    },
  },
  created() {
    this.time_type = 1;
    this.date = [new Date(), new Date()];
    this.getList();
  },
};
</script>
<style lang="scss" scoped>
.container {
  padding: 20px;
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}
.searchbox {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 20px;
  align-items: center;
  box-sizing: border-box;
  .item {
    margin-right: 14px;
  }
}
.num_box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
  border-radius: 2px;
  margin-bottom: 20px;
  .datebox {
    box-shadow: 0 0 5px 0 #d7d7d7;
    border-radius: 10px;
    height: 90px;
    line-height: 90px;
    width: 240px;
    margin-right: 30px;
    font-weight: 700;
    font-size: 20px;
  }
  .num_item {
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 90px;
    width: 18%;
    box-shadow: 0 0 5px 0 #d7d7d7;
    border-radius: 10px;
  }
  .num_item:before {
    content: "";
  }
  .gray {
    font-size: 14px;
    color: #747981;
  }
  .num {
    font-size: 24px;
    font-weight: 600;
    color: #669961;
  }
}
</style>